import * as redukers from 'redukers'
import * as actionTypes from './action-types'
import { combineReducers } from 'redux'

/* eslint-disable-next-line */
export default combineReducers({
  all: redukers.value(
    {
      set: actionTypes.SET_ENERGIES,
      reset: actionTypes.CLEAR_ENERGIES,
    },
    []
  ),
})
